import { render, staticRenderFns } from "./MenuNav.vue?vue&type=template&id=66395a9e&scoped=true&"
import script from "./MenuNav.vue?vue&type=script&lang=js&"
export * from "./MenuNav.vue?vue&type=script&lang=js&"
import style0 from "./MenuNav.vue?vue&type=style&index=0&id=66395a9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66395a9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VNavigationDrawer})
